import { render } from "./RcsOnboardingProgress.vue?vue&type=template&id=0b395ff0"
import script from "./RcsOnboardingProgress.vue?vue&type=script&lang=ts"
export * from "./RcsOnboardingProgress.vue?vue&type=script&lang=ts"
script.render = render

export default script